import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { BankingStatusDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-banking-status-container',
  templateUrl: './banking-status-container.component.html',
  styleUrls: ['./banking-status-container.component.scss']
})
export class BankingStatusContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  bankingstatuss$: Observable<BankingStatusDto[]>;
  loading: boolean;
  isLoadingBankingStatus$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingBankingStatus$ = this.gatwayFacade.isLoadingGateway("BankingStatus");
    this.bankingstatuss$ = this.gatwayFacade.loadGateway("BankingStatus");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteBankingStatus(deletedValue: any) {
    this.gatwayFacade.remove("BankingStatus", deletedValue);
  }


// this method control both the create and update

  onSubmitBankingStatus(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.BankingStatuss;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllBankingStatus = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllBankingStatus.push(pullData[i]);
    }
  }

// check if the addAllBankingStatus array is not empty, then dispatch the data to the store
   if(addAllBankingStatus.length > 0) {
    this.gatwayFacade.add('BankingStatus', addAllBankingStatus);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('BankingStatus', allUpdates, ['id']);
  }

   }


}
